import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
    selector: 'credits-system-settings-page',
    templateUrl: './credits-system-settings.component.html',
    styleUrls: ['./credits-system-settings.component.scss'],
    standalone: false
})
export class CreditsSystemSettingsComponent implements OnInit
{
  data;
    constructor(private http: HttpClient)
    {
    }

  ngOnInit()
  {
  }
}
